<div class="customer-create-container">
  <div class="customer-create">
    <div class="company-profile">
      <h3>{{ 'label.CompanyProfile' | translate }}</h3>
      <div class="account-type">
        <span>{{ 'label.AccountType' | translate }}: </span>
        <span>{{
          customer.originalCustomer?.type.name ||
            ('label.NotSelected' | translate)
        }}</span>
      </div>
      <div class="company-name">
        <span>{{ 'label.CompanyName' | translate }}: </span>
        <span>{{
          customer.originalCustomer?.name || ('label.NotSelected' | translate)
        }}</span>
      </div>
      <div class="tax-id">
        <span>{{ 'label.TaxId' | translate }}: </span>
        <span>{{
          customer.originalCustomer?.idNumber ||
            ('label.label.NotSelected' | translate)
        }}</span>
      </div>
    </div>
    <div class="agent-profile">
      <h3 class="agent-header">{{ 'label.Agent' | translate }}</h3>
      <div class="my-position">
        <span>{{ 'label.YourPositionInCompany' | translate }}: </span>
        <span>{{
          customer.customerAgent?.position || ('label.NotSelected' | translate)
        }}</span>
      </div>
      <div class="name">
        <span>{{ 'label.Name' | translate }}: </span>
        <span>{{
          customer.customerAgent?.name || ('label.NotSelected' | translate)
        }}</span>
      </div>
      <div class="surname">
        <span>{{ 'label.Surname' | translate }}: </span>
        <span>{{
          customer.customerAgent?.surname || ('label.NotSelected' | translate)
        }}</span>
      </div>
      <div class="mail">
        <span>{{ 'label.Email' | translate }}: </span>
        <span>{{
          customer.customerAgent?.email || ('label.NotSelected' | translate)
        }}</span>
      </div>
      <div class="phone">
        <span>{{ 'label.Phone' | translate }}: </span>
        <span>{{
          customer.customerAgent?.phone1Number &&
          customer.customerAgent?.phone1Extension
            ? customer.customerAgent?.phone1Number +
              ' ' +
              ('label.ExtPhoneNumer' | translate) +
              ' ' +
              customer.customerAgent?.phone1Extension
            : customer.customerAgent?.phone1Number &&
              !customer.customerAgent?.phone1Extension
            ? customer.customerAgent?.phone1Number
            : ('label.NotSelected' | translate)
        }}</span>
      </div>
      <div class="mobile-number">
        <span>{{ 'label.MobileNumber' | translate }}: </span>
        <span>{{
          customer.customerAgent?.mobilePhoneNumber ||
            ('label.NotSelected' | translate)
        }}</span>
      </div>
    </div>
  </div>
  <div
    class="create-buttons"
    [ngClass]="{ 'is-activated': customer.isAgentActivated }"
  >
    <div class="activation-link" *ngIf="!customer.isAgentActivated">
      <div class="activation-link-input">
        <span class="activation-link-label-text">{{
          'label.ActivationLink' | translate
        }}</span>
        <div #activationLink class="activation-link-label">
          {{ customer.activationUrl }}
        </div>
      </div>
      <button
        class="mybtn"
        (click)="copyText(overlayPanel, $event, customer.activationUrl)"
      >
        <svg-icon src="assets/img/activation-link.svg"></svg-icon>
      </button>
    </div>
    <div class="button-container">
      <button
        class="reject-button"
        (click)="onReject(customer.customerModerationId)"
      >
        {{ 'label.Reject' | translate }}
      </button>
      <button
        class="confirm-button"
        (click)="onApprove(customer.customerModerationId)"
        [disabled]="!customer.isAgentActivated"
      >
        {{ 'label.ConfirmChanges' | translate }}
      </button>
    </div>
  </div>
  <p-overlayPanel #overlayPanel>{{
    'label.CopiedSuccessfully' | translate
  }}</p-overlayPanel>
</div>
